import * as React from 'react';

import EmptyStubContent from '../EmptyStubContent';

const EmptyFollowUp: React.FC = () => {
  return <EmptyStubContent title="Выберите Follow up" text="Выберите Follow up из дерева слева для просмотра" />;
};

export default EmptyFollowUp;
